import { computed, type ComputedRef } from 'vue'
import type { Ref } from 'vue'
import { useElementSize } from '@vueuse/core'

interface Output {
  chartStyles: ComputedRef<Partial<CSSStyleDeclaration>>
}

export default function useFitChartToContainer(containerRef: Ref<null | HTMLElement>): Output {

  const { width: containerWidth } = useElementSize(containerRef)

  const chartStyles = computed(() => {

    return {
      position: 'relative',
      width: containerWidth.value ? `${containerWidth.value}px` : '100%',
    }

  })

  return { chartStyles }

}
